<template>
  <div class="login-wraper w-full h-full flex align-center justify-center lg:col-6 md:col-12">
    <div class="login-box bg-white px-3 pb-2 rounded lg:col-8 sm:col-12">
      <div class="login-heading flex flex-col flex-wrap text-left font-bold my-3 mx-1">
        <h1 class="font-opacity-lg">Recuperar Senha</h1>
        <p class="font-opacity-md">
          Informe seu número de matrícula que enviaremos o link no email cadastrado para redefinir a senha.
        </p>
      </div>
      <SmartInput
        v-model="registration"
        class="mb-2"
        label="N° da Matrícula"
        placeholder="Digite o seu número de matrícula"
        :mask="'#'.repeat(7)"
        name="registration"
        v-validate="'required|length:7|numeric'"
        :error="errors.first('registration')"
        type="tel"
      />
      <SmartButton
        :disabled="formIsValid"
        :loading="isLoading"
        class="lg:col-12 mb-3"
        @click="passwordRequest">
        Enviar link de redefinição
      </SmartButton>
      <a href="#"
        class="text-brand-secondary smart-link block text-center mb-3 mt-2"
        @click='returnLogin'>{{returnText}}</a>
      <SmartModal
        v-if="modal"
        v-bind="modal"
        @close="modal = null">
        {{ modal.text }}
      </SmartModal>
    </div>
  </div>
</template>
<script>
// @flow
import { mapActions } from 'vuex';

export default {
  name: 'ResetPassword',
  data: () => ({
    returnText: location.hash === '#dashboard' ? '« Voltar' : 'Fazer login',
    returnTo: location.hash === '#dashboard' ? 'Dashboard' : 'Login',
    registration: '',
    isLoading: false,
    modal: null
  }),
  methods: {
    ...mapActions({
      sendToken: 'auth/sendToken'
    }),
    passwordRequest() {
      this.isLoading = true;
      const sendRegistration = {
        reset_form: {
          registration: this.registration
        }
      };
      this.sendToken(sendRegistration)
        .then(({ message }) => {
          this.modal = {
            type: 'success',
            title: 'Email enviado!',
            icon: 'accepted',
            buttonText: 'Tudo certo!',
            text: message
          };
        })
        .catch(({ data }) => {
          this.modal = {
            type: 'warning',
            title: 'Matrícula inválida!',
            icon: 'warning',
            buttonText: 'Tente novamente!',
            text: data.message
          };
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    returnLogin() {
      this.$router.push({ name: this.returnTo });
      return false;
    }
  },
  computed: {
    formIsValid() {
      return this.registration.length !== 7;
    }
  },
};
</script>
<style lang="scss">
.text-brand-secondary.smart-link {
  padding: 10px 20px;
  border-radius: 8px;
  &:hover {
    background: rgba(0,0,0,0.025);
    color: #6ab042;
  }
}
</style>